// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { productDetailsFormWrapperStyles } from "@store/Themes/common/mixins/productDetails";
import { formSmallGridProps } from "@store/Themes/common/props/form";
import { VariantLinkModel } from "@store/Framework/Services/ProductServiceV2";
import loadVariants from "@store/Framework/Store/Store/Data/Products/Handlers/LoadVariants";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import { buttonStyles } from "@store/Themes/common/mixins/button";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    loadVariants,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & HasProduct;

export interface ProductDetailsVariantLinkListStyles {
    wrapper?: InjectableCss;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
}

export const productDetailsVariantLinkListStyles: ProductDetailsVariantLinkListStyles = {
    wrapper: { css: productDetailsFormWrapperStyles() },
    gridContainer: mergeProps<ProductDetailsVariantLinkListStyles["gridContainer"]>(formSmallGridProps.gridContainer, {
        css: css`
            padding-top: ${pxToRem(20)};
            border-top: 1px solid ${getColor("common.border")};
        `,
    }),
    gridItem: { width: 12 },
};

export interface ProductDetailsVariantLinkStyles {
    wrapper?: InjectableCss;
    button?: ButtonPresentationProps;
    labelWrapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
}
export const productDetailsVariantLinkStyles: ProductDetailsVariantLinkStyles = {
    button: {
        sizeVariant: "medium",
        css: css`
            ${buttonStyles("solid")}
            margin-right: ${pxToRem(5)};
            margin-top: ${pxToRem(5)};
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: inherit;
            text-transform: none;
        `,
    },
    labelText: {
        css: css`
            display: inline-block;
            width: 100%;
            ${({ theme }) => {
                return css`
                    font-weight: ${theme.design.typography.size.small};
                    font-weight: ${theme.design.typography.weight.semibold};
                `;
            }}
            margin-bottom: ${pxToRem(5)};
        `,
    },
};

const listStyles = productDetailsVariantLinkListStyles;
const styles = productDetailsVariantLinkStyles;

const ProductDetailsVariantLink = ({ product, loadVariants }: Props) => {
    const [variantLinkList, setVariantLinkList] = useState<VariantLinkModel[] | undefined>(undefined);

    useEffect(() => {
        if (product && !variantLinkList) {
            loadVariants({
                productVariantsApiParameter: {
                    productId: product.id,
                },
                onSuccess: result => {
                    setVariantLinkList(result.variantTraits);
                },
                onError: () => {},
            });
        }
    }, [product, variantLinkList]);

    if (!variantLinkList) {
        return null;
    }

    const renderVariantsLinkList = (variantLinkType: VariantLinkModel) => {
        return (
            <StyledWrapper {...styles.wrapper} key={variantLinkType.id}>
                <StyledWrapper {...styles.labelWrapper}>
                    <Typography {...styles.labelText}>{variantLinkType.name}</Typography>
                </StyledWrapper>
                {variantLinkType.products?.map(variantProduct => {
                    const productDetailPath = variantProduct.product?.productUrl;
                    return (
                        <Button
                            {...styles.button}
                            variant={variantProduct.selected ? "secondary" : ("quarternary" as any)}
                            key={`${variantProduct.id}`}
                            disabled={variantProduct.selected}
                            href={productDetailPath}
                        >
                            {variantProduct.value}
                        </Button>
                    );
                })}
            </StyledWrapper>
        );
    };

    return (
        <StyledWrapper {...listStyles.wrapper}>
            <GridContainer {...listStyles.gridContainer}>
                {variantLinkList.map(variantLinkType => (
                    <GridItem key={variantLinkType.name} {...listStyles.gridItem}>
                        {renderVariantsLinkList(variantLinkType as VariantLinkModel)}
                    </GridItem>
                ))}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(withProduct(ProductDetailsVariantLink)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
